const category_list = {
    heard_title: "Product list",
    heard_btn: "Add",
    form_ph1: "product category",
    table_label1: "Classification Name",
    table_label2: "Sort",
    table_btn1: "Edit",
    table_btn2: "Delete",
    dialog_title1: "Product Category",
    dialog_label1: "Category name:",
    dialog_label2: "Sort by category:",
    rule_msg1: "Sort must be numeric",
    rule_msg2: "Sort has been repeated",
    rule_msg3: "Please enter a category name"
};

export default category_list;
